import { jsx as _jsx } from "react/jsx-runtime";
import { BKJListItem } from '../../BKJListItem/index.js';
import { useBKJComboBoxContext } from './BKJComboBox.context.js';
export const BKJComboBoxItem = (props) => {
    const { getItemProps, highlightedIndex, name, value, handleMultiSelectClick } = useBKJComboBoxContext();
    const isSelected = value.includes(`${props.value}`);
    const itemProps = getItemProps({
        item: props,
        isSelected,
        index: props.index,
        value: props.value,
        label: props.label,
        selected: isSelected,
        checked: isSelected,
        disabled: !!props.disabled,
        style: props.style,
        name,
    });
    const checkBoxVariantConfig = props.overrides && !!props.overrides.includes('CHECKBOX_VARIANT')
        ? {
            variant: 'LeftAlignRowReverse',
            checkBoxVariant: 'GreenSolid',
            onChange: handleMultiSelectClick,
        }
        : { variant: 'SpaceBetween' };
    return (_jsx(BKJListItem, { ...checkBoxVariantConfig, isTargeted: highlightedIndex === props.index, ...itemProps, subLabel: props?.subLabel, selected: value }));
};
//# sourceMappingURL=BKJComboBoxItem.js.map